// Libraries
import moment from 'moment';

// MUI
// Core
// Common
// Interfaces
import { IModifyNotifications, INotificationResult } from '../interfaces/INotification';

// Store
// API
import { anelmaNotificationsUrl, notificationsUrl } from './apiEndpoints';
import ApiBase from './ApiBase';
import { GUIDType } from '../interfaces/types';
import { IApiResult } from '../interfaces/IGeneral';

// Feature - Notifications

class NotificationApi extends ApiBase {
    getNotifications = (userId: string, farmId: string, snellmanUser: boolean) =>
        this.getList<INotificationResult>(
            `${notificationsUrl}/from/${moment()
                .subtract(30, 'days')
                .format(
                    'YYYY-MM-DDTHH:mm:ss'
                )}/userId/${userId}/farmId/${farmId}/snellmanUser/${snellmanUser}`
        );

    modifyNotifications = (payload: IModifyNotifications) =>
        this.postList<INotificationResult>(`${notificationsUrl}/Modify`, payload);

    sendPreliminaryAnnouncementNotification = (announcementId: GUIDType) =>
        this.post<IApiResult<null>>(`${anelmaNotificationsUrl}/SendPreliminaryAnnouncementNotification/${announcementId}`, {});
}

export default new NotificationApi();
